import axios from "axios";

class UserSignatureProfileService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Lucia Alvarado
   * @description Get all signature profiles assigned to the user
   * @date 18-01-2022
   * @param {String} token
   * @param {Number} userId
   * @returns {Object}
   * @memberof UserSignatureProfileService
   */

  async getUserSignatureProfiles(token, userId) {
    let response = await axios.get(
      `${this.apiUrl}/user-signature-profiles?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Pedro Ramos
   * @description Get all users
   * @date 26-05-2022
   * @param {String} token
   * @param {Number} signatureProfileId
   * @returns {Object}
   * @memberof UserSignatureProfileService
   */

  async getUsersProfiles(token, signatureProfileId) {
    let response = await axios.get(
      `${this.apiUrl}/profile-signature-users?signatureProfileId=${signatureProfileId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Create signature profile and asign to user
   * @date 25-01-2022
   * @param {Array} signatureProfiles
   * @param {String} token
   * @returns {Object}
   * @memberof UserSignatureProfileService
   */
  async createProfilesUser(signatureProfiles, token) {
    let response = await axios.post(
      `${this.apiUrl}/user-signature-profile`,
      {
        signatureProfiles,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Delete signature profile and asign to user
   * @updatedDate 10-03-2022
   * @param {Array [Object]} signatureProfiles
   * @param {String} token
   * @returns {Object}
   * @memberof UserSignatureProfileService
   */
  async deleteUserProfiles(signatureProfiles, token) {
    let response = await axios.delete(
      `${this.apiUrl}/user-signature-profile?signatureProfiles=${signatureProfiles}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Delete signature profile and asign to user
   * @date 25-01-2022
   * @param {String} token
   * @param {Number} id
   * @returns {Object}
   * @memberof UserSignatureProfileService
   */
  async deleteUserProfileById(id, token) {
    let response = await axios.delete(
      `${this.apiUrl}/user-signature-profile?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }
}

export { UserSignatureProfileService as default };
